export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10568.6a9d9632.jpg";